import { FC } from 'react';
import { Texts } from '../Texts';

/* Styles */
import styles from './Progressbar.module.scss';

interface ProgressbarProps {
  className?: string;
  progress: number;
  ariaLabel?: string;
}

export const Progressbar: FC<ProgressbarProps> = ({
  className = '',
  progress = 0,
  ariaLabel = undefined,
}) => {
  const progressValue = Math.floor(progress * 100);

  return (
    <section
      aria-hidden={true}
      className={`${styles.progressbar} ${className}`}
      aria-label={ariaLabel}
    >
      <div className={styles.progress} style={{ width: `${progressValue}%` }}>
        <Texts>{`${progressValue}%`}</Texts>
      </div>
    </section>
  );
};
